import { useEffect, useState } from "react";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import PackageCard from "@/components/PackageCard";
import { api } from "@/lib/api";
import { Check, X } from "lucide-react";

export default function Pricing() {
  const [packages, setPackages] = useState([]);
  useEffect(() => { api.get("/packages").then((r) => setPackages(r.data)).catch(() => {}); }, []);

  const rows = [
    ["Life Path & core numbers", ["basic", "complete", "name"]],
    ["Personality & strengths", ["basic", "complete", "name"]],
    ["Career & relationship themes", ["complete"]],
    ["Number interactions", ["complete"]],
    ["Alternative spelling analysis", ["name"]],
    ["Name vs birth-date comparison", ["name"]],
  ];
  const has = (slugs, s) => slugs.includes(s);

  return (
    <>
      <Seo title="Pricing & Packages" path="/pricing" description="Numerology report packages from ₹120. Basic, Complete Life Report, and Name Numerology Analysis." />
      <PageHeader eyebrow="Pricing & Packages" title="Simple, honest pricing"
        subtitle="Pay once per report. Prices in INR. Every report is personalized and delivered as a premium PDF within approximately 6–7 hours." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 items-start">
          {packages.map((p) => <PackageCard key={p.slug} pkg={p} />)}
        </div>

        {/* Comparison */}
        <div className="mt-20 overflow-x-auto">
          <h2 className="font-serif text-3xl text-navy mb-8">What's included</h2>
          <table className="w-full min-w-[560px] border-collapse" data-testid="pricing-comparison-table">
            <thead>
              <tr className="border-b-2 border-navy">
                <th className="text-left py-4 pr-4 text-sm font-medium text-slate-500">Feature</th>
                {packages.map((p) => (
                  <th key={p.slug} className="py-4 px-3 text-center font-serif text-lg text-navy">
                    {p.name.split(" ")[0]}<br /><span className="text-gold text-sm">₹{p.price_inr}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map(([label, slugs]) => (
                <tr key={label} className="border-b border-border">
                  <td className="py-4 pr-4 text-sm text-slate-700">{label}</td>
                  {packages.map((p) => (
                    <td key={p.slug} className="py-4 px-3 text-center">
                      {has(slugs, p.slug)
                        ? <Check className="w-5 h-5 text-gold-hover mx-auto" />
                        : <X className="w-4 h-4 text-slate-300 mx-auto" />}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
}
